import { render, staticRenderFns } from "./serviceContent.vue?vue&type=template&id=731874e8&scoped=true"
import script from "./serviceContent.vue?vue&type=script&lang=js"
export * from "./serviceContent.vue?vue&type=script&lang=js"
import style0 from "./serviceContent.vue?vue&type=style&index=0&id=731874e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731874e8",
  null
  
)

export default component.exports